import { api } from "./api";

export const balance = async (): Promise<any> => {
  const { data } = await api.get("/finance/balance");
  return data;
};

export const extract = async (params: any): Promise<any> => {
  const { data } = await api.get("/finance/extract", { params });
  return data;
};

export const extractPayments = async (params: any): Promise<any> => {
  const { data } = await api.get("/finance/extract-payments", { params });
  return data;
};

export const transferDetails = async (id: string): Promise<any> => {
  const { data } = await api.get("/finance/extract/" + id);
  return data;
};

export const paymentDetails = async (id: string): Promise<any> => {
  const { data } = await api.get("/finance/payment/" + id);
  return data;
};

export const pixKeyList = async (): Promise<any> => {
  const { data } = await api.get("/finance/pix/key");
  return data;
};

export const pixKeyDelete = async (id: string): Promise<any> => {
  const { data } = await api.delete("/finance/pix/key/" + id);
  return data;
};

export const pixTransfer = async (body: any): Promise<any> => {
  const { data } = await api.post("/finance/pix/transfer", body);
  return data;
};

export const pixKeyCreate = async (): Promise<any> => {
  const { data } = await api.post("/finance/pix/key", {
    type: "EVP",
  });
  return data;
};

export const reprocessPayment = async (id: string): Promise<any> => {
  const { data } = await api.put("/finance/payment/reprocess/" + id);
  return data;
};

export const payWithBillet = async (id: string): Promise<any> => {
  const { data } = await api.put("/finance/payment/with-billet/" + id);
  return data;
};

// ── Mercado Pago ────────────────────────────────────────────

export const payWithCreditCardById = async (body: {
  paymentId: string | number;
  cardToken: string;
  paymentMethodId: string;
  issuerId?: string;
  installments?: number;
}): Promise<any> => {
  const { data } = await api.post("/finance/payment/with-credit-card", body);
  return data;
};

export const getMpAuthUrl = async (): Promise<{ url: string }> => {
  const { data } = await api.get("/finance/mercadopago/auth-url");
  return data;
};

export const getMpStatus = async (): Promise<{
  connected: boolean;
  mpUserId: string | null;
  connectedAt: string | null;
}> => {
  const { data } = await api.get("/finance/mercadopago/status");
  return data;
};

export const getMpDisconnect = async (): Promise<{ message: string }> => {
  const { data } = await api.delete("/finance/mercadopago/disconnect");
  return data;
};
